export const getAuthHeader = (
  headers: [string, string][] | Record<string, string> | Headers,
): string | null => {
  if (Array.isArray(headers))
    return headers.find(r => r[0].toLowerCase() === 'authorization')?.[1] ?? null

  if (headers instanceof Headers) return headers.get('authorization')

  return headers.authorization ?? null
}

export const setAuthHeader = <RequestType extends { headers?: any }>(
  request: RequestType,
  newToken: string,
): RequestType => {
  if (Array.isArray(request.headers)) {
    return {
      ...request,
      headers: [
        ...request.headers.filter(([header]) => header.toLowerCase() !== 'authorization'),
        ['authorization', newToken],
      ],
    }
  }

  if (request.headers instanceof Headers) {
    request.headers.set('authorization', newToken)
    return request
  }

  return { ...request, headers: { ...request.headers, authorization: newToken } }
}
